import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { JSEncrypt } from 'jsencrypt';

import { OTP, Typography } from 'mobily-ui-library/lib';
import { GlobalContext } from '../../context/GlobalContext';

import { cemValidateOTP, getAccountByNumber, cemResendOTP } from '../../api/api.ts';

import HeaderNavigation from '../HeaderNavigation/HeaderNavigation';
import ErrorModal from '../ErrorModal/ErrorModal';

import './DeviceOTP.scss';


interface Props {
    timer: number;
    setTimer: (value: any) => void;
    handleHeaderCancel: () => void;
}

const win: any = window;

function DeviceOTP({ handleHeaderCancel, setTimer, timer }: Props) {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, msisdn, OTPData, productData } = state;
    const { t } = useTranslation();
    
    const [otpValue, setotpValue] = useState('');
    const [showOTPError, setShowOTPError] = useState(false);
    const [notCustomer, setNotCustomer] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [isAppleCareError, setIsAppleCareError] = useState(false);
    const [isGenericError, setIsGenericError] = useState(false);
    const [resendOption, setResendOption] = useState(true);
    const [isOTPDisabled, setIsOTPDisabled] = useState(false);
    const [errorCode, setErrorCode] = useState('');
    const cemPublicKey = win['cem_public_key'];
    const jsencrypt = new JSEncrypt();
    jsencrypt.setPublicKey(cemPublicKey);
    const bmClientId = win['BM_CI'];
    const bmClientSecret = win['BM_CS'];

    const refId = OTPData?.data?.refId ? OTPData?.data?.refId : "";


    useEffect(() => {
        let countdown: any;
        const countdownFunction = () => {
            countdown = setInterval(() => {
                setTimer((prevTimer: any) => {
                    if (prevTimer > 0) {
                        return prevTimer - 1;
                    } else {
                        clearInterval(countdown);
                        return 0;
                    }
                });
            }, 1000);
        }
        countdownFunction();

        return () => clearInterval(countdown);
    }, [setTimer, timer]);

    const formatTime = (time: any) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    const handleOTPChange = (otp: any) => {
        setotpValue(otp);

        if (otp.length === 4) {
            dispatch({ type: "LOADER", payload: { loading: true } });
            dispatch({ type: "CAPTURE_OTP_VALUE", payload: { otpValue: otp } });
            // validateOTPAPI(otp);
            cemValidateOTPAPI(otp)
        }
    }

    const handleNotCustomer = () => {
        dispatch({ type: "LOADER", payload: { loading: false } });
        dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: 'login' } });
        setNotCustomer(false);
        // childRef?.current?.removeMobileNumber();
    }
    const handleAppleCarePopup = () => {
        dispatch({ type: "LOADER", payload: { loading: false } });
        setIsAppleCareError(false);
        dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: 'cartPage' } });
    }

    const handleGenericError = () => {
        dispatch({ type: "LOADER", payload: { loading: false } });
        setIsGenericError(false);
        dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: 'cartPage' } });
    }

    const cemValidateOTPAPI = (otp: any) => {
        const EnBmClientId = bmClientId ? jsencrypt.encrypt(bmClientId) : "";
        const EnBmClientSecret = bmClientSecret ? jsencrypt.encrypt(bmClientSecret) : "";
        const req = { otp, refId, EnBmClientId, EnBmClientSecret };

        cemValidateOTP(req)
            .then((res: any) => {
                if (res.status === 200) {
                    if (res?.data?.status?.sourceCode === "MAPI-000") {
                        dispatch({ type: "LOADER", payload: { loading: true } });
                        const pNumber = msisdn.length > 0 ? msisdn.replace(/^0/, '966') : '';
                        const accessToken = res?.data?.data?.access_token;
                        getAccountByNumberApi(pNumber, accessToken);
                    } else {
                        setErrorCode(res?.data?.status?.sourceCode);
                        setIsGenericError(true);
                        dispatch({ type: "LOADER", payload: { loading: false } });
                    }
                } else if (res?.status === 260) {
                    // Handle otp error cases
                    switch (res?.data?.status?.sourceCode) {
                        case "MAPI-260-2":
                            setErrorMessage(t("error_Invalid_OTP"));
                            setShowOTPError(true);
                            break;
                        case "MAPI-260-3":
                            setErrorMessage(t("error_OTP_expired"));
                            setShowOTPError(true);
                            break;
                        case "MAPI-260-4":
                            setIsOTPDisabled(true);
                            setErrorMessage(t("error_Max_attempt_reached"));
                            setShowOTPError(true);
                            break;
                        default:
                            setErrorCode(res?.data?.status?.sourceCode);
                            setIsGenericError(true);
                            break;
                    }
                    setTimer(0);
                    setotpValue('');
                    dispatch({ type: "LOADER", payload: { loading: false } });
                } else {
                    setErrorCode(res?.status);
                    setIsGenericError(true);
                    dispatch({ type: "LOADER", payload: { loading: false } });
                }
            }).catch((err: any) => {
                dispatch({ type: "LOADER", payload: { loading: false } });
                setErrorCode(err?.response?.status);
                setIsGenericError(true);
            })
    }

    const getAccountByNumberApi = (msisdn: string, accessToken: any) => {
        let preorderFilter = productData?.getProductOfferByID[0]?.specCharValueUse.filter(
            (val: any) => val.name === "Is Eligible For Pre Order"
        )[0];
        let isEligibileForPreOrder = preorderFilter
            ?.specCharacteristicValue[0]?.value
            ? preorderFilter?.specCharacteristicValue[0]?.value
            : "false";
        getAccountByNumber(msisdn, isEligibileForPreOrder, accessToken)
            .then((res: any) => {
                if (res.status === 200 && res.data) {
                    if (res.data?.MSISDN) {
                        dispatch({ type: 'CUSTOMER_ACCOUNT_BY_NUMBER', payload: { customerAccount: res?.data } })
                        if ((res?.data?.PackageCategory?.toUpperCase() === "VOICE") &&
                            (res?.data?.CustomerType?.toUpperCase() === "CONSUMER") &&
                            (res?.data?.IUCFlag?.toUpperCase() !== "Y") && (res?.data?.NewStack !== "Y")) {
                            dispatch({ type: 'CUSTOMER_INFO', payload: { customerInfo: res?.data } })
                            dispatch({ type: 'NEW_STACK', payload: { newStack: res?.data?.NewStack } })
                            dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: "DeviceTerms" } })
                            dispatch({ type: "LOADER", payload: { loading: false } });
                        } else {
                            dispatch({ type: "LOADER", payload: { loading: false } });
                            setIsAppleCareError(true);
                        }
                    } else {
                        setNotCustomer(true);
                        dispatch({ type: "LOADER", payload: { loading: false } });
                    }
                } else {
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    setErrorCode(res?.status);
                    setIsGenericError(true);
                }
            }).catch((err: any) => {
                dispatch({ type: "LOADER", payload: { loading: false } });
                setErrorCode(err?.response?.status);
                setIsGenericError(true);
            })
    }


    const handleResend = () => {
        dispatch({ type: "LOADER", payload: { loading: true } })

        cemResendOTP(refId)
            .then((res: any) => {
                if (res?.status === 204) {
                    setotpValue('');
                    setIsOTPDisabled(false);
                    dispatch({ type: "LOADER", payload: { loading: false } })
                    setTimer(120);
                    setShowOTPError(true);
                } else if (res?.status === 260 && res?.data?.status?.sourceCode === "MAPI-260-1") {
                    setTimer(0);
                    setotpValue('');
                    setResendOption(false);
                    setErrorMessage(t("error_exceed_maxmium_amount"));
                    dispatch({ type: "LOADER", payload: { loading: false } });
                } else {
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    setErrorCode(res?.status);
                    setIsGenericError(true);
                }
            })
            .catch(err => {
                dispatch({ type: "LOADER", payload: { loading: false } });
                    setErrorCode(err?.response?.status);
                    setIsGenericError(true);
            })
    }

    const handleBackArrow = () => {
        dispatch({ type: "LOADER", payload: { loading: false } })
        dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: "cartPage" } })
    }



    return (
        <div className="container AppleCare__Container">
            <HeaderNavigation
                rtl={rtl}
                percent={50}
                showBackArrow={true}
                handleBackArrow={handleBackArrow}
                handleHeaderCancel={handleHeaderCancel}
            />
            <div className='Verify__Container'>
                <div className='SL__headerText'>
                    <Typography rtl={rtl} id="verify-heading" className='SL__heading'>{t('Verify_heading')}</Typography>
                    <Typography rtl={rtl} id="verify-Subheading" className='SL__subHeading'>
                        {t('Verify_Subheading')}
                        <div className='Verify__Msisdn'>{msisdn}.</div>
                        <div>{t('Verify_ToContinue')}</div>
                    </Typography>
                </div>

                <div className='Verify__OTP'>
                    <OTP id="otp-input" isDisabled={isOTPDisabled} rtl={rtl} numInputs={4} onChange={handleOTPChange} value={otpValue} />
                    {timer > 0 ? (
                        <Typography id="resend-code" rtl={rtl} className='Verify__timer'>
                            {t('Verify_ResendNewCode')} <span>{formatTime(timer)}</span>
                        </Typography>
                    ) : showOTPError ? (
                        <Typography className='Verify__otpError' rtl={rtl}>
                            {errorMessage}
                            {resendOption && <span id='resend-otp' className='Verify__sendAgain_error' onClick={handleResend}>
                                {t("Send_again")}
                            </span>}

                        </Typography>
                    ) : (
                        <Typography className='Verify__Resend' rtl={rtl}>
                            {t("Didnt_receive_the_code")}
                            <span id='resend-otp' className='Verify__sendAgain' onClick={handleResend}>
                                {t("Send_again")}
                            </span>
                        </Typography>
                    )}
                </div>

                {notCustomer && (
                    <ErrorModal
                        id={'not-a-mobily-number'}
                        rtl={rtl}
                        title={t('Not_a_mobily_number')}
                        description={t('we_didnot_recognize_number')}
                        firstButtonText={t('got_it')}
                        modalFirstButtonClick={handleNotCustomer}
                    />
                )}
                {isAppleCareError && (
                    <ErrorModal
                        id={'apple-care-not-eligible'}
                        rtl={rtl}
                        title={t('your_plan_not_eligible')}
                        description={t('plan_not_eligible_for_appleCare')}
                        firstButtonText={t('got_it')}
                        modalFirstButtonClick={handleAppleCarePopup}
                    />
                )}
                {isGenericError && (
                    <ErrorModal
                        id={'otp_page_generic_error'}
                        rtl={rtl}
                        title={""}
                        description={t('Try_again', { source_code: t(errorCode) })}
                        firstButtonText={t('got_it')}
                        modalFirstButtonClick={handleGenericError}
                    />
                )}
            </div>
        </div>
    )
}

export default DeviceOTP